// @flow
const interfaceObject = __CLIENT__ ? window.AppInterface || {} : {};

const appInterface: {
  updateProfile: (any) => void,
  iwpStatus: (string) => void
} = new Proxy(interfaceObject, {
  get(target, prop, receiver) {
    if (!(prop in target)) {
      return (args) => {
        // eslint-disable-next-line no-console
        console.warn(
          `Attempted to call AppInterface with the undefined function "${prop}" with the arguments`,
          args
        );
      };
    }

    return Reflect.get(target, prop, receiver);
  }
});

export default appInterface;
